import { ChangeDetectionStrategy, Component, Injector, ViewChild } from "@angular/core";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { ArrayUtilities } from "@common/lib/utilities/array-utilities";
import { SortUtilities } from "@common/lib/utilities/sort-utilities";
import { IDxListItemDeletedEvent } from "@common/ux/dx.types";
import { DirectorySharedService } from "@org-common/lib/directory-shared/directory-shared.service";
import { SelectPersonComponent } from "@org-common/lib/directory-shared/select-person/select-person.component";
import { WorkflowStepComponent } from "@org-common/lib/workflow/workflow-component-registry";
import { lastValueFrom } from "rxjs";
import { AddTeamWorkflowStepBaseComponent } from "../add-team-workflow-step-base.component";

@WorkflowStepComponent("adapt-add-team-members-step")
@Component({
    selector: "adapt-add-team-members-step",
    templateUrl: "./add-team-members-step.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AddTeamMembersStepComponent extends AddTeamWorkflowStepBaseComponent {
    public teamLeaderLabel$ = this.teamsService.getTeamLeaderLabel$();
    public teamMembersLabel$ = this.teamsService.getTeamMemberLabelPlural$();

    @ViewChild("selectTeamMember") public selectTeamMemberComponent?: SelectPersonComponent;

    public constructor(
        injector: Injector,
        private directorySharedService: DirectorySharedService,
    ) {
        super(injector);
    }

    @Autobind
    public filterAvailable(person: Person) {
        const { memberPersonIds, teamLeaderPersonId } = this.runData.createTeamBindingModel;
        return !memberPersonIds.includes(person.personId) && teamLeaderPersonId !== person.personId;
    }

    @Autobind
    public async onTeamMemberPersonChange(person?: Person) {
        if (person) {
            const { memberPersonIds } = this.runData.createTeamBindingModel;

            ArrayUtilities.addElementIfNotAlreadyExists(memberPersonIds, person.personId);

            // get the person entities, sort by name, then use those indexes to sort the IDs
            const personIds = (await lastValueFrom(this.directorySharedService.primePeopleWithIds(memberPersonIds)))
                .sort(SortUtilities.getSortByFieldFunction<Person>("fullName"))
                .map((p) => p.personId);
            memberPersonIds.sort((a, b) => personIds.indexOf(a) - personIds.indexOf(b));

            this.selectTeamMemberComponent?.reset();
        }
    }

    public async removeMember(e: IDxListItemDeletedEvent<number>) {
        if (e.itemData) {
            ArrayUtilities.removeElementFromArray(e.itemData, this.runData.createTeamBindingModel.memberPersonIds);
            this.selectTeamMemberComponent?.reset();
        }
    }
}
